<template>
  <div id="productos">
    <div class="container">

      <div class="group">
         <div class="color amarillo"></div>
        <router-link to="/durazno">
          <div class="frutas" style="">
            <div class="overlay">
              <p>Durazno</p>
            </div>
          </div>
        </router-link>
      </div>
       <div class="group">
           <div class="color azul"></div>
            <router-link to="/uva">
              <div class="frutas">
                <div class="overlay">
                  <p>Uva</p>
                </div>
              </div>
            </router-link>
       </div>
       <div class="group">
           <div class="color amarillo"></div>
            <router-link to="peraAsiatica">
        <div class="frutas">
          <div class="overlay">
            <p>Pera Asiática</p>
          </div>
        </div>
      </router-link>
       </div>
       <div class="group">
           <div class="color amarillo"></div>
            <router-link to="/litchi">
        <div class="frutas">
          <div class="overlay">
            <p>Litchi</p>
          </div>
        </div>
      </router-link>
       </div>
       <div class="group">
           <div class="color azul"></div>
            <router-link to="/pera">
        <div class="frutas">
          <div class="overlay">
            <p>Pera</p>
          </div>
        </div>
      </router-link>
       </div>
       <div class="group">
           <div class="color amarillo"></div>
            <router-link to="/fresa">
        <div class="frutas">
          <div class="overlay">
            <p>Fresa</p>
          </div>
        </div>
      </router-link>
       </div>
       <div class="group">
           <div class="color amarillo"></div>
            <router-link to="/berries">
        <div class="frutas">
          <div class="overlay">
            <p>Berries</p>
          </div>
        </div>
      </router-link>
       </div>
       <div class="group">
           <div class="color azul"></div>
            <router-link to="/nectarina">
        <div class="frutas">
          <div class="overlay">
            <p>Nectarina</p>
          </div>
        </div>
      </router-link>
       </div>
       <div class="group">
           <div class="color amarillo"></div>
            <router-link to="/aguacate">
        <div class="frutas">
          <div class="overlay">
            <p>Aguacate</p>
          </div>
        </div>
      </router-link>
       </div>
       <div class="group">
           <div class="color amarillo"></div>
            <router-link to="/melon">
        <div class="frutas">
          <div class="overlay">
            <p>Melón</p>
          </div>
        </div>
      </router-link>
       </div>
       <!-- <div class="group">
           <div class="color azul"></div>
            <router-link to="/mango">
        <div class="frutas">
          <div class="overlay">
            <p>Mango</p>
          </div>
        </div>
      </router-link>
       </div> -->
       <div class="group">
           <div class="color azul"></div>
            <router-link to="/ciruela">
        <div class="frutas">
          <div class="overlay">
            <p>Ciruela</p>
          </div>
        </div>
      </router-link>
       </div>
       <div class="group">
           <div class="color amarillo"></div>
            <router-link to="/manzana">
        <div class="frutas">
          <div class="overlay">
            <p>Manzana</p>
          </div>
        </div>
      </router-link>
       </div>
       <div class="group">
           <div class="color amarillo"></div>
            <router-link to="/higo">
        <div class="frutas">
          <div class="overlay">
            <p>Higo</p>
          </div>
        </div>
      </router-link>
       </div>
       <div class="group">
           <div class="color azul"></div>
            <router-link to="/cereza">
        <div class="frutas">
          <div class="overlay">
            <p>Cereza</p>
          </div>
        </div>
      </router-link>
       </div>
        <div class="group">
          <div class="color amarillo"></div>
            <!-- <router-link to="/"> -->
             <div class="frutas">
              <!-- <div class="overlay">
                <p></p>
              </div> -->
           </div>
          <!-- </router-link> -->
       </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },

};
</script>

<style lang="scss">

    .container {
      overflow: hidden;
      margin:  50px auto;
      // display: -ms-grid;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(33.33%, 1fr));
      height: 240vh;
      width: 80%;

      .color {
        width: 100%;
        height: 5%;
      }
      .group {
        overflow: hidden;
      }
      .amarillo {
        background: yellow;
      }
      .azul {
        background: blue;
      }
      .frutas {
        position: relative;
        width: 100%;
        height: 100%;

        & > .overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 10;
          background: rgba($color: #000000, $alpha: 0.7);
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          transition: all .3s;

          p {
            color: #fff;
            font-size: 3em;
          }
        }
        &:hover > div.overlay {
          opacity: 1;
        }

        img {
          width: 100%;
          max-width: 100%;
          height: 100%;
        }
      }
      .group:nth-child(1) .frutas {
        background: url('../assets/images/grid/1.jpg');
        background-position: center;
        background-size: cover;
      }
     .group:nth-child(2) .frutas {
        background: url('../assets/images/grid/uva.jpg');
        background-position: center;
        background-size: cover;
      }
     .group:nth-child(3) .frutas {
        background: url('../assets/images/grid/peraAsiatica.png');
        background-position: center;
        background-size: cover;
      }
     .group:nth-child(4) .frutas {
        background: url('../assets/images/grid/litchi.jpg');
        background-position: center;
        background-size: cover;
      }
     .group:nth-child(5) .frutas {
        background: url('../assets/images/grid/pera3-min.jpg');
        background-position: center;
        background-size: cover;
      }
     .group:nth-child(6) .frutas {
        background: url('../assets/images/grid/6.jpg');
        background-position: center;
        background-size: cover;
      }
     .group:nth-child(7) .frutas {
        background: url('../assets/images/grid/7.jpg');
        background-position: center;
        background-size: cover;
      }
     .group:nth-child(8) .frutas {
        background: url('../assets/images/grid/nectarina.png');
        background-position: center;
        background-size: cover;
      }
     .group:nth-child(9) .frutas {
        background: url('../assets/images/grid/aguacate.jpg');
        background-position: center;
        background-size: cover;
      }
     .group:nth-child(10) .frutas {
        background: url('../assets/images/grid/melon.png');
        background-position: center;
        background-size: cover;
      }
     .group:nth-child(11) .frutas {
        background: url('../assets/images/grid/ciruela.jpg');
        background-position: center;
        background-size: cover;
      }
      .group:nth-child(12) .frutas {
        background: url('../assets/images/grid/13.jpg');
        background-position: center;
        background-size: cover;
      }
      .group:nth-child(13) .frutas {
        background: url('../assets/images/grid/14.jpg');
        background-position: center;
        background-size: cover;
      }
      .group:nth-child(14) .frutas {
        background: url('../assets/images/grid/15.jpg');
        background-position: center;
        background-size: cover;
      }
      .group:nth-child(15) .frutas {
        background: url('../assets/images/grid/Group133.png');
        background-position: center;
        background-size: cover;
       }
    }
  @media screen and (max-width: 1024px) {
    .container{
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)) !important;
  }
  }
  @media screen and (max-width: 600px) {
    #recetas div.container {
      height: auto !important;
    }
    div#productos {
      margin-top: -9vh;
    }
    div.container {
      height: auto;
      margin: 50px 0;
      width: 100%;
    }
    .container .group {
      height: 40vh;
    }
  }
</style>
